import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Details, Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";

import { NOTIFY, DEFAULTS, FORMATS } from "common/config";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUCCESS,
  WARNINGS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import { ApiGeography } from "apihandlers/geography";
import { DateFunctions } from "common/datefunctions";
import RadioBtn from "components/Custom/RadioBtn";

const ApiGeographyHandler = new ApiGeography();

const Route = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [area, setAreas] = useState();
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const fromTypeRef: any = useRef(null);
  const toTypeRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getAreas();
    }
  }, [loading]);

  const getAreas = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    ApiGeographyHandler.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setAreas(list);
        getRows();
      }
    });
  };

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await ApiGeographyHandler.getRoutes(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getUserTypes:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "startPlace",
      name: LABELS.START_PLACE,
      type: "text",
      width: "25%",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "endPlace",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.END_PLACE,
      width: "25%",
      align: "center",
    },
    {
      key: "routeDetail",
      name: LABELS.ROUTE_DETAILS,
      type: "text",
      width: "25%",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "activeStatus",
      name: LABELS.ACTIVE_STATUS,
      type: "dropdown",
      editable: false,
      sortable: true,
      searchable: true,
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      width: "15%",
      align: "center",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageRoute = () => {
    const startPoint = fromTypeRef.current.selectedValue.id;
    const endPoint = toTypeRef.current.selectedValue.id;
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";

    const distanceInKm = (
      document.getElementById("distance") as HTMLInputElement
    ).value.trim();
    const dist = parseInt(distanceInKm) * 1000;

    const durationInMin = (
      document.getElementById("duration") as HTMLInputElement
    ).value.trim();

    const reachBy = (
      document.getElementById("reachBy") as HTMLInputElement
    ).value.trim();
    let errors = [];

    if (!startPoint) {
      errors.push({
        id: "startPlace",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!endPoint) {
      errors.push({
        id: "endPlace",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      startId: startPoint,
      endId: endPoint,
      details: [
        {
          distance: {
            text: distanceInKm + " km",
            value: dist,
          },
          duration: {
            text: DateFunctions.convSecondsToString(Number(durationInMin) * 60),
            value: durationInMin,
          },
          end_location: {
            lat: " ",
            lng: " ",
          },
        },
      ],
      reachBy,
      activeStatus: activeStatus,
      actualRoute: "true",
    };
    console.log("args:", args);
    console.log("selectkm", args.details);
    // console.log("deatilString :", args.details);
    // let distance = JSON.parse(args.details)[0].distance.text;
    // console.log("details[0].text :", distance);
    // let duration = JSON.parse(args.details)[1].duration.text;
    // console.log("details[1].text :", duration);
    setIsSubmit(true);
    ApiGeographyHandler.manageRoute(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  // let detail = [];
  // if (selectedRow.details) {
  //   const parsedDetails = JSON.parse(selectedRow.details[0].distance.text);
  //   detail.push(parsedDetails);
  // }
  // console.log("detail:", selectedRow.startPlace);
  // console.log("detail: ", selectedRow.details);

  let routeDistance = "";
  let routeDuration = "";
  if (selectedRow.details) {
    const detailsJson = JSON.parse(selectedRow.details);
    console.log("detailsJson:", detailsJson);
    routeDistance = detailsJson[0].distance.text.replace(" km", "");
    routeDuration = detailsJson[0].duration.value;
  }

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.ROUTE}</li>
        </ul>
        <h4>{TITLES.ROUTE}</h4>
        <p className="SubTitles">{SUB_TITLES.ROUTE}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.ROUTE}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.ROUTE}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.ROUTE + ": " + selectedRow.routeDetail
              : "Add New " + TITLES.ROUTE
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="flexColumn">
            <div className="formGroup red">
              <label>
                {LABELS.FROM_DATE}
                {<span>{" *"}</span>}
              </label>

              <AutoComplete
                list={area}
                childRef={fromTypeRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.startId,
                        label: selectedRow.startPlace,
                      }
                    : null
                }
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup red">
              <label>
                {LABELS.TO_DATE}
                {<span>{"*"}</span>}
              </label>
              <AutoComplete
                list={area}
                childRef={toTypeRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.endId,
                        label: selectedRow.endPlace,
                      }
                    : null
                }
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup ">
              <TxtRow
                id={"distance"}
                type={"number"}
                label={LABELS.ROUTE_DISTANCE}
                defaultValue={routeDistance}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup">
              <TxtRow
                id={"duration"}
                label={LABELS.ROUTE_DURATION}
                type={"number"}
                defaultValue={routeDuration}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup">
              <TxtRow
                id={"reachBy"}
                label={LABELS.REACH_BY}
                type={"time"}
                defaultValue={selectedRow.reachBy}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup">
              <label>{LABELS.ACTIVE_STATUS}</label>
              <RadioBtn
                list={[
                  {
                    id: "activeYes",
                    value: "Yes",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "activeNo",
                    value: "No",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                disabled={isSubmit}
              />
            </div>
            {/* mandatoryResults */}
            {mandatoryResults.length > 0 && (
              <div className="mandatoryBox">
                <ul>
                  {mandatoryResults.map((m) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            <div className="formGroup submitBtnWrapper">
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.CANCEL}
                  // loading={isSubmit}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    setManageDialog(false);
                    setMandatoryResults([]);
                  }}
                  routeDistance
                />
                <Btn
                  text={LABELS.SAVE}
                  loading={isSubmit}
                  onClick={manageRoute}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Route);
